import '../common/styles/main.scss';

import { Route, Routes } from 'react-router-dom';

import PageNotFound from './shared/notFound/PageNotFound';
import ChatbotSessionRequest from './unauthenticated/ChatbotSessionRequest';
import CirclesInvite from './unauthenticated/CirclesInvite';
import ForgotPassword from './unauthenticated/ForgotPassword';
import InvitationSignIn from './unauthenticated/InvitationSignIn';
import InvitationSignUp from './unauthenticated/InvitationSignUp';
import PasswordReset from './unauthenticated/PasswordReset';
import SetPassword from './unauthenticated/SetPassword';
import SignIn from './unauthenticated/SignIn';
import SupportAccessRightRequest from './unauthenticated/SupportAccessRightRequest';
import VerifyEmail from './unauthenticated/VerifyEmail';
import UnAuthenticatedBase from './UnAuthenticatedBase';

export default function UnAuthenticatedApp() {
  return (
    <UnAuthenticatedBase>
      <Routes>
        <Route path="set-password" element={<SetPassword />} />
        <Route path="account-instructions" element={<SetPassword />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<PasswordReset />} />
        <Route path="invitation">
          <Route path="sign-up" element={<InvitationSignUp />} />
          <Route path="sign-in" element={<InvitationSignIn />} />
        </Route>
        <Route path="circles">
          <Route path="invite" element={<CirclesInvite />} />
        </Route>
        <Route path="sign-in" element={<SignIn />} />
        <Route
          path="support-access-rights"
          element={<SupportAccessRightRequest />}
        />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="chatbot-session" element={<ChatbotSessionRequest />} />
        {/* FIXME: The PageNotFound component doesn't work well with the UnAuthenticatedBase template */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </UnAuthenticatedBase>
  );
}
